import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';

import { produce } from 'immer';
import {
  SetSpecification,
  SpecificationAddWareItems,
  SpecificationDeleteWareItems,
  SpecificationReplaceWareItems,
  SpecificationUpdateWareItems,
  UpdateSpecification,
} from './specification.actions';
import { SpecificationStateModel } from '../../../../../types/specification';

@State<SpecificationStateModel>({
  name: 'specification',
  defaults: {
    specification: null,
    wares: [],
  },
})
@Injectable()
export class SpecificationState {
  @Action(SetSpecification)
  setSelectedSpecification(
    ctx: StateContext<SpecificationStateModel>,
    action: SetSpecification,
  ) {
    const { wares, ...rest } = action.specification;
    ctx.patchState({
      specification: rest,
      wares,
    });
  }

  @Action(UpdateSpecification)
  updateSpecification(
    ctx: StateContext<SpecificationStateModel>,
    action: UpdateSpecification,
  ) {
    ctx.patchState({
      specification: action.specification,
    });
  }

  @Selector()
  static getSpecification(state: SpecificationStateModel) {
    return state.specification;
  }

  @Selector()
  static getWares(state: SpecificationStateModel) {
    return state.wares;
  }

  @Action(SpecificationUpdateWareItems)
  dtImportUpdateWareItems(
    ctx: StateContext<SpecificationStateModel>,
    action: SpecificationUpdateWareItems,
  ) {
    ctx.setState(
      produce(draft => {
        action.wares.forEach(wareItem => {
          const id = wareItem.id;
          const index = ctx.getState().wares.findIndex(i => i.id === id);
          if (index !== null) {
            draft.wares.splice(index, 1, wareItem);
          }
        });
      }),
    );
  }

  @Action(SpecificationDeleteWareItems)
  specificationDeleteWareItems(
    ctx: StateContext<SpecificationStateModel>,
    action: SpecificationDeleteWareItems,
  ) {
    ctx.setState(
      produce(draft => {
        draft.wares.splice(0);
        draft.wares.push(...action.wares);
      }),
    );
  }

  @Action(SpecificationReplaceWareItems)
  specificationReplaceWares(
    ctx: StateContext<SpecificationStateModel>,
    action: SpecificationReplaceWareItems,
  ) {
    ctx.setState(
      produce(draft => {
        draft.wares.splice(0);
        draft.wares.push(...action.wares);
      }),
    );
  }

  @Action(SpecificationAddWareItems)
  specificationAddWareItems(
    ctx: StateContext<SpecificationStateModel>,
    action: SpecificationAddWareItems,
  ) {
    ctx.setState(
      produce(draft => {
        draft.wares?.push(...action.wares);
      }),
    );
  }
}
